import { useCallback, useMemo } from 'react';
import { useActionSectionKeys, useQuickActionSettings } from '../../../hooks/useCardSections';
import { AddQuickActions } from './AddQuickActions';
import { useUpdateDraftQuickActions } from './quickActionActions';
// @ts-expect-error dependency missing types
import UISortableList from 'ui-addon-draggable/list/UISortableList';
// @ts-expect-error dependency missing types
import UIDragListHandle from 'ui-addon-draggable/draggable/UIDragListHandle';
// @ts-expect-error dependency missing types
import UIDragListItem from 'ui-addon-draggable/list/UIDragListItem';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSectionTitle } from '../../../utils/getSectionTitle';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyleDragList = styled.div.withConfig({
  displayName: "QuickActionSettings__StyleDragList",
  componentId: "sc-1pbi02b-0"
})([".quick-action-item-container{flex-grow:0;flex-shrink:0;flex-basis:", ";width:", ";padding-inline-start:", ";padding-inline-end:", ";}.quick-action-list{display:flex;flex-direction:row;}"], ({
  numItems
}) => `${100 / numItems}%`, ({
  numItems
}) => `${100 / numItems}%`, ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.space['100']);
export const QuickActionSettings = () => {
  const actionSectionKeys = useActionSectionKeys();
  const quickActionSettings = useQuickActionSettings();
  const updateDraftQuickActions = useUpdateDraftQuickActions();
  const settings = useMemo(() => {
    return quickActionSettings || {
      settings: {
        quickActions: []
      }
    };
  }, [quickActionSettings]);
  const selectedKeys = useMemo(() => {
    return settings.settings.quickActions.slice(0).sort((a, b) => a.displayOrder - b.displayOrder).map(({
      type
    }) => {
      return type;
    }).filter(type => {
      //only render things we support
      return actionSectionKeys.includes(type);
    });
  }, [settings, actionSectionKeys]);
  const handleSelectedKeysChange = useCallback(selected => {
    const removed = settings.settings.quickActions.filter(({
      type
    }) => {
      return selected.indexOf(type) > -1;
    });
    const added = selected.filter(type => {
      return !settings.settings.quickActions.some(({
        type: existingType
      }) => existingType === type);
    }).map(type => ({
      type: type,
      displayOrder: -1
    }));
    const merged = [...removed, ...added];
    const updated = merged.map(({
      type
    }, index) => ({
      type: type,
      displayOrder: index
    }));
    updateDraftQuickActions(updated);
  }, [settings, updateDraftQuickActions]);
  const handleOrderChange = useCallback(order => {
    const updated = order.map((type, index) => ({
      type: type,
      displayOrder: index
    }));
    updateDraftQuickActions(updated);
  }, [updateDraftQuickActions]);
  const handleRemoveQuickAction = useCallback(removedType => {
    const removed = settings.settings.quickActions.filter(({
      type: existingType
    }) => existingType !== removedType).map(({
      type
    }) => type);
    handleSelectedKeysChange(removed);
  }, [settings, handleSelectedKeysChange]);

  //@bend-expect trellis-tokenized
  const orderedItems = useMemo(() => {
    return selectedKeys.map(type => {
      return /*#__PURE__*/_jsx(UIDragListItem, {
        compact: true,
        dragId: type,
        draggable: true,
        className: "quick-action-item-container",
        children: /*#__PURE__*/_jsx(UIDragListHandle, {
          position: "start",
          children: /*#__PURE__*/_jsx("div", {
            style: {
              height: '100%'
            },
            children: /*#__PURE__*/_jsxs(Flex, {
              boxShadow: "100",
              borderRadius: "100",
              paddingBlock: "300",
              paddingInlineStart: "600",
              paddingInlineEnd: "300",
              "data-test-id": `quick-action-item`,
              blockSize: "100%",
              flexDirection: "column",
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsx(Text, {
                display: "block",
                marginBlockEnd: "100",
                children: getSectionTitle(type)
              }), /*#__PURE__*/_jsx(View, {
                children: /*#__PURE__*/_jsx(Button, {
                  size: "extra-small",
                  use: "tertiary-light",
                  onClick: () => handleRemoveQuickAction(type),
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "crmObjectBoardCard.settings.quickActions.remove"
                  })
                })
              })]
            })
          })
        })
      }, type);
    });
  }, [selectedKeys, handleRemoveQuickAction]);
  if (actionSectionKeys.length === 0) {
    return null;
  }
  const selectedKeysLength = selectedKeys.length;
  //@bend-expect trellis-tokenized
  //@bend-expect trellis-tokenized
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    alignItems: "stretch",
    "data-test-id": "board-card-section-setting-properties-list",
    children: [/*#__PURE__*/_jsx(AddQuickActions, {
      actionKeys: actionSectionKeys,
      selected: selectedKeys,
      onSelectedPropertyChange: handleSelectedKeysChange
    }), /*#__PURE__*/_jsx(StyleDragList, {
      numItems: selectedKeysLength,
      children: /*#__PURE__*/_jsx(UISortableList, {
        className: "quick-action-list",
        dragGroup: "quick-actions",
        direction: "horizontal",
        order: selectedKeys,
        animate: false,
        onOrderChange: handleOrderChange,
        children: orderedItems
      })
    })]
  });
};